import { Outlet } from 'react-router-dom';
import Content from '../../../components/content';

export function TemplatesLayout() {
    return (
        <Content headerTitle="Templates" backNavLink="/settings">
            {{ content: <Outlet /> }}
        </Content>
    );
}
